import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reportId: null,
  viewType: "small-view",
  // reportFavLoadingIds: [],
  applicationFavLoadingIds: [],
  editingFavLayout: false,
  searchText: "",
  reportDetailsView: "details",
  groupBy: "app_category",
  reportRegisterData: {
    reportType: "report",
  },
  filterBy: [],
  standAloneAppRegisterData: {},
  isDarkMode: "light",
  myAppsActiveTab: 0,
  discoverActiveTab: 0,
  savedActiveTab: 0,
  // isDarkMode: false,
  showRecommendation: false,
  userFilters: {},
  showPowerBiSignIn: false,
};

const selectionsSlice = createSlice({
  name: "selections",
  initialState,
  reducers: {
    updateSelectedReportId(state, action) {
      state.reportId = action.payload;
    },
    resetSelectedReportId(state) {
      state.reportId = null;
    },
    updateViewType(state, action) {
      state.viewType = action.payload;
    },
    updateEditingFavLayout(state, action) {
      state.editingFavLayout = action.payload;
    },
    addApplicationInFavLoading(state, action) {
      state.applicationFavLoadingIds.push(action.payload);
    },
    removeApplicationFromFavLoading(state, action) {
      state.applicationFavLoadingIds = state.applicationFavLoadingIds.filter(
        (id) => id !== action.payload
      );
    },
    updateSearchText(state, action) {
      state.searchText = action.payload;
    },
    resetSearchText(state) {
      state.searchText = "";
    },
    updateDatasetRegisterData(state, action) {
      state.datasetRegisterData = action.payload;
    },
    updateReportRegisterData(state, action) {
      state.reportRegisterData = action.payload;
    },
    updateStandAloneAppRegisterData(state, action) {
      state.standAloneAppRegisterData = action.payload;
    },
    updateReportDetailsView(state, action) {
      state.reportDetailsView = action.payload;
    },
    toggleTheme(state) {
      state.isDarkMode = !state.isDarkMode;
    },
    updateMyAppsActiveTab(state, action) {
      state.myAppsActiveTab = action.payload;
    },
    updateTheme(state, action) {
      state.isDarkMode = action.payload;
    },
    updateDiscoverActiveTab(state, action) {
      state.discoverActiveTab = action.payload;
    },
    updateSavedActiveTab(state, action) {
      state.savedActiveTab = action.payload;
    },
    toggleRecommendation(state, action) {
      if (action.payload) state.showRecommendation = action.payload;
      else state.showRecommendation = !state.showRecommendation;
    },
    updateUserFilters(state, action) {
      state.userFilters = action.payload;
    },
    updatePowerBiSignIn(state, action) {
      state.showPowerBiSignIn = action.payload;
    },
  },
});

export const {
  resetSelectedReportId,
  updateSelectedReportId,
  updateViewType,
  updateEditingFavLayout,
  addApplicationInFavLoading,
  removeApplicationFromFavLoading,
  resetSearchText,
  updateSearchText,
  updateDatasetRegisterData,
  updateReportRegisterData,
  updateReportDetailsView,
  updateStandAloneAppRegisterData,
  toggleTheme,
  updateTheme,
  updateMyAppsActiveTab,
  updateDiscoverActiveTab,
  updateSavedActiveTab,
  toggleRecommendation,
  updateUserFilters,
  updatePowerBiSignIn,
} = selectionsSlice.actions;
export default selectionsSlice.reducer;
